import type { IMessage } from 'src/services/api';
import { EMessageDirection } from 'src/services/api/messages/types';

const LANG_DETECTION_WINDOW = 5;

/**
 * Returns the most frequent non-English BCP-47 language code found in the
 * last N inbound messages, or null if all detected languages are English /
 * no qualifying messages exist.
 */
export function detectLeadLanguage(messages: IMessage[]): string | null {
    const recentInbound = messages
        .filter(m => m.direction === EMessageDirection.IN && m.lang != null)
        .slice(-LANG_DETECTION_WINDOW);

    const counts: Record<string, number> = {};
    for (const msg of recentInbound) {
        const lang = msg.lang!;
        if (lang !== 'en') {counts[lang] = (counts[lang] ?? 0) + 1;}
    }

    const entries = Object.entries(counts);
    if (!entries.length) {return null;}
    return entries.reduce((a, b) => b[1] > a[1] ? b : a)[0];
}
